import PropTypes from 'prop-types';

const CustomIcon = ({ icon: Icon, size = 32, color = 'inherit', ...props }) => {
    return <Icon style={{ width: size, height: size, color, ...props.sx }} />;
};
CustomIcon.propTypes = {
    icon: PropTypes.elementType.isRequired,
    size: PropTypes.number,
    color: PropTypes.string
};
export default CustomIcon;